var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"noteLinesTableComponent"},[_c('paginated-client-table',{attrs:{"title":_vm.title,"header-class":"bg-success","small":"","default-per-page":5,"fields":_vm.tableColumns,"tableItems":_vm.notesLines}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }